/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function AddIntegrationController($scope, $mdDialog, $state, $stateParams, $document, $q, types, integrationService, entityTableConfiguration) {

    var vm = this;

    vm.$onInit = function () {
        vm.entityTableConfiguration = entityTableConfiguration;

        vm.entity = {};

        vm.entityType = vm.entityTableConfiguration.entityType;
        vm.translations = types.entityTypeTranslations[vm.entityType];

        vm.add = add;
        vm.cancel = cancel;
    };

    function cancel() {
        $mdDialog.cancel();
    }

    function add() {
        if ($stateParams.applicationId) {
            vm.entity.applicationId = {
                entityType: types.entityType.application,
                id: $stateParams.applicationId
            };
        }
        integrationService.saveIntegration(vm.entity).then(
            (entity) => {
                vm.entity = entity;
                $scope.theForm.$setPristine();
                $mdDialog.hide();
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/integration/add-integration.controller.js